import React, { useState } from "react";
import { Link } from "react-router";
import { Fragment } from "react";
import {
  CopyIcon,
  MoonIcon,
  SearchIcon,
  SunIcon,
} from "../../../assets/icons/index";
import Constant from "../../../utils/constant";
import { connect } from "react-redux";
import { Logout } from "../../../assets/icons/index";
import nightwind from "nightwind/helper";
import logoWhite from "../../../assets/images/acadamics-dallas.svg";
import logoBlack from "../../../assets/images/acadamics-dallas-dark.svg";
import CopyToClipBoard from "../common/copyToClipboard";
import { Configuration } from "../../../environment/setup";
import { logout } from "../../../redux/thunks/userProfileThunk";

const Header: React.FC<any> = (props: any) => {
  type Theme = "Dark" | "Light";

  const [toggleTheme, setToggleTheme] = useState<Theme>("Light");
  const isDevSite =
    location.href.indexOf(Configuration.Dev_URL?.toString() ?? "") > 0
      ? true
      : false;
  const isQaSite = location.href.includes("qa") ? true : false;
  const [open, setOpen] = useState<boolean>(false);

  function handleToggle() {
    setToggleTheme(toggleTheme === "Dark" ? "Light" : "Dark");
    nightwind.toggle();
    props.checkIsDarkTheme(toggleTheme === "Dark" ? false : true);
  }

  const openCloseClip = () => {
    setOpen(!open);
  };

  const logoutAndClear = () => {
    props.logout();
  };

  return (
    <>
      <nav
        className={`mx-auto px-4 sm:px-4 lg:px-4 w-full shadow-lg relative z-10 ${
          isDevSite ? "bg-green-400" : isQaSite ? "bg-blue-400" : ""
        } dark:bg-custom-black`}
      >
        <div className=" ">
          <div className="flex w-full">
            <div className="flex flex-row items-center">
              <div>
                <Link to={"/dashboard"}>
                  <div className="relative">
                    <img
                      className={`h-16 dark:hidden max-w-[180px]`}
                      src={logoWhite}
                      alt="progress cms"
                    />
                    <img
                      className={`hidden dark:inline-block h-16 max-w-[180px]`}
                      src={logoBlack}
                      alt="progress cms 1"
                    />
                    {isDevSite && (
                      <span className="absolute bottom-[6px] right-0 text-xs text-white dark:text-white">
                        Development
                      </span>
                    )}
                    {isQaSite && (
                      <span className="absolute bottom-[6px] right-0 text-xs text-white dark:text-white">
                        Quality Assurance
                      </span>
                    )}
                  </div>
                </Link>
              </div>
            </div>
            <div className="flex items-center justify-between w-full pl-20 ml-2">
              <div className="flex items-center w-full max-w-[400px]">
                <div className="flex rounded-md shadow-sm relative w-full">
                  <input
                    type="text"
                    name="search"
                    id="search"
                    className={`${
                      isDevSite ? "bg-gray-200" : ""
                    } searchInput focus:ring-primary-color focus:border-primary-color dark:focus:ring-gray-500 dark:focus:border-gray-500 block w-full rounded-lg dark:bg-custom-black dark:text-white sm:text-sm border-gray-300 pl-8 py-1.5`}
                    placeholder="Search..."
                  />
                  <SearchIcon className="absolute w-3.5 top-2.5 left-3 text-gray-500"></SearchIcon>
                </div>
                <script
                  dangerouslySetInnerHTML={{ __html: nightwind.init() }}
                />
              </div>

              <div className="hidden sm:ml-6 sm:flex sm:items-center font-Open-Sans">
                <div className="ml-3 relative flex space-x-8 items-center">
                  <div title="Copied question ids">
                    <CopyIcon
                      className={` h-6 w-6 cursor-pointer ${
                        isDevSite
                          ? "text-gray-500 hover:text-gray-600"
                          : isQaSite
                          ? "text-gray-500 hover:text-gray-600"
                          : "text-gray-400 hover:text-gray-500"
                      }`}
                      onClick={openCloseClip}
                    />
                  </div>
                  {open && (
                    <div className="absolute mt-6 -left-5">
                      <CopyToClipBoard openCloseClip={openCloseClip} />
                    </div>
                  )}
                  <div>
                    {toggleTheme === "Light" && (
                      <MoonIcon
                        className="ml-2 w-6 cursor-pointer hover:opacity-80"
                        onClick={() => handleToggle()}
                      />
                    )}
                    {toggleTheme === "Dark" && (
                      <SunIcon
                        className="ml-2 w-6 cursor-pointer hover:opacity-80"
                        onClick={() => handleToggle()}
                      />
                    )}
                  </div>
                  <div className="flex items-center justify-end whitespace-nowrap">
                    <button
                      type="button"
                      className="hover:text-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 gap-2 cursor-pointer"
                      id="user-menu-button"
                      x-ref="button"
                    >
                      <span className="sr-only">Open user menu</span>
                      <img
                        className="h-6 w-6 rounded-full"
                        src="http://www.gravatar.com/avatar/3b3be63a4c2a439b013787725dfce802?d=identicon"
                        alt=""
                      />
                      <span
                        className={`${
                          isDevSite ? "text-white" : "text-gray-700"
                        } hover:opacity-80 dark:text-white`}
                      >
                        {props?.profile?.firstName} {props?.profile?.lastName}
                      </span>
                    </button>
                  </div>
                  <div>
                    <Link
                      onClick={() => logoutAndClear()}
                      to={Constant.DEFAULT}
                    >
                      <Fragment>
                        <button
                          type="button"
                          className="max-w-xs focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 gap-1 cursor-pointer"
                          id="user-menu-button"
                          aria-expanded="false"
                          aria-haspopup="true"
                        >
                          <span
                            className={`dark:text-white hover:opacity-80 ${
                              isDevSite ? "text-white" : ""
                            }`}
                          >
                            Logout
                          </span>
                          <Logout
                            className={`h-5 dark:text-white ${
                              isDevSite ? "text-white" : ""
                            }`}
                          ></Logout>
                        </button>
                      </Fragment>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    logout: () => {
      dispatch(logout());
    },
  };
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
